let Errors = require("./errors").default;
let moment = require("moment");

export default class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data, errors) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = errors || new Errors();
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            if (property === "images" && this[property] instanceof Array) {
                data[property] = this[property].map(function (value) {
                    if (value instanceof File) {
                        return value;
                    } else {
                        return value.id;
                    }
                });
            } else {
                data[property] = this[property] === null ? "" : this[property];
            }
        }

        return data;
    }

    /**
     * 
     * @param {*} data 
     */
    formdata(data) {
        var d = new FormData();
        for (let property in data) {
            if (data[property] instanceof Array) {
                data[property].forEach(element => {
                    d.append(property + "[]", element);
                });
            } else {
                d.append(property, data[property]);
            }
        }
        return d;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            if (field === "lat" || field === "lng") {
                this[field] = 0;
            } else if (field === "event_date") {
                this[field] = moment().format("YYYY-MM-DD");
            } else {
                this[field] = "";
            }
        }

        this.errors.clear();
    }


    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     * @param {boolean} isSubmit
     */
    post(url, isSubmit = true) {
        if (isSubmit)
            return this.submit("post", url);
        return this.validate("post", url);
    }


    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit("put", url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit("patch", url);
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit("delete", url);
    }

    /**
     * Validate the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    checkDuplicates(requestType, url) {
        return new Promise((resolve, reject) => {
            axios[requestType](url, this.data())
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        reject(error.response.data);
                    } else {
                        reject("error");
                    }
                });
        });
    }

    /**
     * Validate the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    validate(requestType, url) {
        return new Promise((resolve, reject) => {
            axios[requestType](url, this.data())
                .then(response => {
                    this.onValidationSuccess(response.data);

                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.onFail(error.response.data.errors);

                        reject(error.response.data);
                    } else {
                        reject("error");
                    }
                });
        });
    }

    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        return new Promise((resolve, reject) => {
            axios[requestType](url, this.formdata(this.data()), { headers: { "Content-Type": "multipart/form-data" } })
                .then(response => {
                    this.onSuccess(response.data);

                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        if (error.response.data.errors)
                            this.onFail(error.response.data.errors);

                        reject(error.response.data);
                    } else {
                        reject(false);
                    }
                });
        });
    }

    /**
     * Handle a successful form validation.
     *
     * @param {object} data
     */
    onValidationSuccess(data) {
        // alert(data.message); // temporary
    }

    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        //alert(data.message); // temporary

        this.reset();
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors);
    }
}